<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #cell(cash_reference_full_code)="{ item }">
            {{ item.causale.codice }} - {{ item.causale.descrizione }}
          </template>
          <template #cell(entry_in)="{ item }">
            {{
              item.causale.tipo_di_movimento === 0
                ? toLocaleCurrency(Math.abs(item.importo))
                : toLocaleCurrency(0)
            }}
          </template>
          <template #cell(entry_out)="{ item }">
            {{
              item.causale.tipo_di_movimento === 1
                ? toLocaleCurrency(Math.abs(item.importo))
                : toLocaleCurrency(0)
            }}
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>

              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                :disabled="!isStandard(row.item)"
                @click="onEdit(row.item.id, row.item)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('destroy')"
                :disabled="!isStandard(row.item)"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id, row.item)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>
          <!-- <template
            slot="thead-top"
            slot-scope="data"
            v-if="Object.keys(current_balance).length && items.length"
          >
            <td v-for="(field, i) in data.fields" :key="i" class="totalRow">
              <span
                v-if="i !== 0 && field.key === 'descrizione'"
                v-html="`Saldo del ${toLocaleDate(current_balance_date)}`"
              >
              </span>
              <span
                v-if="i !== 0 && field.key === 'entrate'"
                class="info"
                v-html="
                  `${
                    current_balance?.saldo > 0
                      ? toLocaleCurrency(Math.abs(current_balance.saldo))
                      : toLocaleCurrency(0)
                  }`
                "
              >
              </span>
              <span
                v-if="i !== 0 && field.key === 'uscite'"
                class="info"
                v-html="
                  `${
                    current_balance?.saldo < 0
                      ? toLocaleCurrency(Math.abs(current_balance.saldo))
                      : toLocaleCurrency(0)
                  }`
                "
              >
              </span>
            </td>
          </template> -->
          <template #empty>
            <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
          </template>
          <template slot="bottom-row" v-if="type && noPagination === false">
            <td colspan="8">
              <div class="row pagination--intable">
                <div class="show-text">
                  <p>Mostra</p>
                </div>

                <div class="group">
                  <b-form-group
                    label-for="per-page-select"
                    label-cols-sm="3"
                    label-cols-md=""
                    label-cols-lg="3"
                    label-size="sm"
                    md="auto"
                  >
                    <b-form-select
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      style="width: 68px"
                      size="sm"
                      @change="onPageChange(1)"
                      :disabled="!items.length"
                    ></b-form-select>
                  </b-form-group>
                </div>

                <div class="page">
                  <p>di {{ totalItems }} per pagina</p>
                </div>
                <div class="pagination" v-if="totalItems">
                  <b-pagination
                    v-model="currentPage"
                    limit="3"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    size="sm"
                    @change="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </td>
          </template>
          <template
            slot="custom-foot"
            slot-scope="data"
            v-if="Object.keys(current_balance).length && items.length"
          >
            <td
              v-for="(field, i) in data.fields"
              :key="i"
              class="totalRow totalRow--upper-pagination"
            >
              <span
                v-if="i !== 0 && field.key === 'descrizione'"
                v-html="
                  `<br><br>Saldo del ${toLocaleDate(current_balance_date)}`
                "
              >
              </span>
              <span
                v-if="i !== 0 && field.key === 'entrate'"
                class="info"
                v-html="
                  `${toLocaleCurrency(
                    Math.abs(current_balance.entrate),
                  )}<br><br>${
                    current_balance.saldo >= 0
                      ? toLocaleCurrency(Math.abs(current_balance.saldo))
                      : ''
                  }`
                "
              >
              </span>
              <span
                v-if="i !== 0 && field.key === 'uscite'"
                class="info"
                v-html="
                  `${toLocaleCurrency(
                    Math.abs(current_balance.uscite),
                  )}<br><br>${
                    current_balance.saldo < 0
                      ? toLocaleCurrency(Math.abs(current_balance.saldo))
                      : ''
                  }`
                "
              >
              </span>
            </td>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <b-row v-if="!type && noPagination === false">
        <div class="show-text">
          <p>Mostra</p>
        </div>

        <div class="group">
          <b-form-group
            label-for="per-page-select"
            label-cols-sm="3"
            label-cols-md=""
            label-cols-lg="3"
            label-size="sm"
            md="auto"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              style="width: 68px"
              size="sm"
              @change="onPageChange(1)"
              :disabled="!items.length"
            ></b-form-select>
          </b-form-group>
        </div>

        <div class="page">
          <p>di {{ totalItems }} per pagina</p>
        </div>
        <div class="pagination" v-if="totalItems">
          <b-pagination
            v-model="currentPage"
            limit="3"
            :total-rows="totalItems"
            :per-page="perPage"
            size="sm"
            @change="onPageChange"
          ></b-pagination>
        </div>
      </b-row>
      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import template from "./template";
import General from "@/components/profile/companies-products/insurers/details/General";
import BaseIcon from "@/components/BaseIcon";
import {toLocaleCurrency} from "@/utils/strings";
import {toLocaleDate} from "@/utils/dates";
import {mapActions} from "vuex";
import EmptyTable from "@/components/EmptyTable.vue";
import moment from "moment";

moment.locale("it");
export default {
  name: "CashEntriesNoFcTable",
  extends: template,
  data() {
    return {
      tabs: [{name: "General", text: "Generale"}],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
    };
  },
  components: {
    General,
    BaseIcon,
    EmptyTable,
  },
  mounted() {
    console.log("previous_balance", this.previous_balance);
  },
  methods: {
    toLocaleCurrency,
    toLocaleDate,
    fetchPage(val) {
      this.$parent.currentPage = val;
      this.currentPage = val;
      let filter = this.keepFilter();
      this.$parent.fetch(this.$parent.filterName).then(() => {
        if (filter) {
          let name = this.filterName;
          this.removeFilterByName(name);
          this.removePaginationByName(name);
        }
      });
    },
    isStandard(item) {
      return item?.cash_reference?.reference_type?.value === 0;
    },
    totalBalance() {
      return (
        Math.abs(parseFloat(this.current_balance.entrate)) -
        Math.abs(parseFloat(this.current_balance.uscite)) +
        Math.abs(parseFloat(this.previous_balance.entrate)) -
        Math.abs(parseFloat(this.previous_balance.uscite))
      );
    },
    ...mapActions("filters", {
      // saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", {removePaginationByName: "removeByName"}),
  },
  props: {
    type: {
      type: String,
      default() {
        return "";
      },
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    previous_balance_date: {
      type: String,
      default() {
        return "";
      },
    },
    current_balance_date: {
      type: String,
      default() {
        return "";
      },
    },
    previous_balance: {
      type: Object,
      default() {
        return {};
      },
    },
    current_balance: {
      type: Object,
      default() {
        return {};
      },
    },
    cash_reference_full_code: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/table-mixins";

.info {
  text-align: right;
}

@include accounting-table-totals($summary-cells: true);
</style>